import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RepliesList from './RepliesList';
import CommentForm from './CommentForm';
import BasicComment from './BasicComment';

export default class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReply: false,
    };
  }

  toggleReply = () => {
    this.setState({ showReply: true }, () => {
      this.replyInput.focus();
    });
  }

  submitReply = (replyText) => {
    this.props.submitReply(this.props.comment.id, replyText);
  }

  toggleReplyLike = (replyId, liked) => {
    this.props.toggleLike(replyId, liked, 'reply', this.props.comment.id);
  }

  deleteReply = (replyId) => {
    this.props.deleteReply(replyId, this.props.comment.id);
  }

  reportReply = (replyId) => {
    this.props.reportReply(replyId, this.props.comment.id);
  }

  render() {
    const { comment, loggedInUser, toggleLike, deleteComment, reportComment } = this.props;
    const { id, deleted, replies } = comment;

    return (
      deleted === false &&
        <div className="comment">
          <BasicComment
            userAccess={loggedInUser.computed_access}
            comment={comment}
            onLikeClick={toggleLike}
            onDeleteClick={deleteComment}
            onReportClick={reportComment}
            onReplyClick={this.toggleReply}
          />

          {replies && replies.length > 0 &&
            <div className="comment__replies-container">
              <RepliesList
                replies={replies}
                loggedInUser={loggedInUser}
                toggleLike={this.toggleReplyLike}
                deleteReply={this.deleteReply}
                reportReply={this.reportReply}
                toggleReply={this.toggleReply}
              />
            </div>
          }

          {this.state.showReply &&
            <div className="comment__reply-form">
              <CommentForm
                loggedInUser={loggedInUser}
                placeholder="Write a reply... press enter to submit"
                onSubmit={this.submitReply}
                inputRef={(input) => { this.replyInput = input; }}
                btnText="Reply"
                commentId={id}
              />
            </div>
          }
        </div>
    );
  }
}

Comment.propTypes = {
  comment: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object,
  deleteComment: PropTypes.func,
  reportComment: PropTypes.func,
  toggleLike: PropTypes.func,
  submitReply: PropTypes.func,
  deleteReply: PropTypes.func,
  reportReply: PropTypes.func,
};



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/Comment.js